import React, { Component } from 'react';
import { Row, Col, Card, CardBody } from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { BaseUrl } from "../../helpers/Baseurl";

class PaxDetail extends Component {
    constructor(props) {
        super(props);
        console.log("PaxDetail Constructor - Props received:", props);
        this.state = {
            itinerary: null,
            loading: true,
            error: null,
        };
        toastr.options = {
            positionClass: "toast-top-right",
            closeButton: "false",
            progressBar: "true",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut",
            showDuration: 300,
            hideDuration: 1000,
            timeOut: 5000,
            extendedTimeOut: 1000
        };
    }

    componentDidCatch(error, info) {
        console.error("ComponentDidCatch:", error, info);
        this.setState({ error: error.message });
    }

    async componentDidMount() {
        console.log("ComponentDidMount - Props:", this.props);
        if (!this.props.data.id) {
            console.error("No itineraryId provided in props:", this.props);
            this.setState({ loading: false, error: "No itineraryId provided" });
            return;
        }
        await this.loadItinerary();
    }

    async loadItinerary() {
        const itineraryId = this.props.data.id;
        // console.log(itineraryId,"ddd")
        console.log("loadItinerary - Using itineraryId:", itineraryId);
        const requestOptions = {
            method: 'GET',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.access}` 
            },
        };
        try {
            console.log("Fetching itinerary for ID:", itineraryId);
            const response = await fetch(`${BaseUrl}/api/itineraries/itineraries/${itineraryId}/`, requestOptions);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const data = await response.json();
            console.log("Fetched itinerary data:", data);
            this.setState({ itinerary: data, loading: false, error: null });
        } catch (error) {
            console.error("Error loading itinerary:", error);
            this.setState({ loading: false, error: error.message });
        }
    }

    async handleCountChange(newCount, row) {
        const { itinerary } = this.state;
        const currentCount = row.count || 0;
        const difference = newCount - currentCount;

        let updatedFields = {
            adults_male: itinerary.adults_male || 0,
            adults_female: itinerary.adults_female || 0,
            teens_male: itinerary.teens_male || 0,
            teens_female: itinerary.teens_female || 0,
            kids_male: itinerary.kids_male || 0,
            kids_female: itinerary.kids_female || 0,
        };

        if (row.category.includes('Adults')) {
            if (row.gender === 'Male') {
                updatedFields.adults_male = newCount;
            } else if (row.gender === 'Female') {
                updatedFields.adults_female = newCount;
            }
        } else if (row.category.includes('Teens')) {
            const totalTeens = newCount;
            updatedFields.teens_male = Math.floor(totalTeens / 2);
            updatedFields.teens_female = totalTeens - updatedFields.teens_male;
        } else if (row.category.includes('Kids')) {
            const totalKids = newCount;
            updatedFields.kids_male = Math.floor(totalKids / 2);
            updatedFields.kids_female = totalKids - updatedFields.kids_male;
        }

        updatedFields.pax = updatedFields.adults_male + 
                           updatedFields.adults_female + 
                           updatedFields.teens_male + 
                           updatedFields.teens_female + 
                           updatedFields.kids_male + 
                           updatedFields.kids_female;

        const requestOptions = {
            method: 'PATCH',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.access}`
            },
            body: JSON.stringify(updatedFields)
        };

        try {
            console.log("Updating itinerary with fields:", updatedFields);
            const response = await fetch(`${BaseUrl}/api/itineraries/itineraries/${itinerary.id}/`, requestOptions);
            if (!response.ok) {
                const errorData = await response.json();
                console.error("Server response:", errorData);
                throw new Error(errorData.detail || JSON.stringify(errorData) || "Failed to update itinerary");
            }
            const updatedData = await response.json();
            console.log("Updated itinerary data:", updatedData);
            this.setState({ itinerary: updatedData });
            toastr.success(`Updated count to ${newCount}`, "Success");
        } catch (error) {
            console.error("Error updating itinerary:", error);
            toastr.error(error.message, "Error");
        }
    }

    render() {
        const { itinerary, loading, error } = this.state;

        if (loading) return <div>Loading...</div>;
        if (error) return <div>Error: {error}</div>;
        if (!itinerary) return <div>No itinerary data available</div>;

        const baseGroups = {
            'Adult-Men': { 
                id: 'Adult-Men', 
                category: 'Adults (13-60 years)', 
                gender: 'Male', 
                count: itinerary.adults_male || 0 
            },
            'Adult-Women': { 
                id: 'Adult-Women', 
                category: 'Adults (13-60 years)', 
                gender: 'Female', 
                count: itinerary.adults_female || 0 
            },
            'Teens': { 
                id: 'Teens', 
                category: 'Teens (6-12 years)', 
                gender: 'N/A', 
                count: (itinerary.teens_female || 0) + (itinerary.teens_male || 0) 
            },
            'Kids': { 
                id: 'Kids', 
                category: 'Kids (0-5 years)', 
                gender: 'N/A', 
                count: (itinerary.kids_female || 0) + (itinerary.kids_male || 0) 
            }
        };

        const tableData = Object.values(baseGroups);
        console.log("Table Data:", tableData);

        const paxColumns = [
            { dataField: "id", text: "id", hidden: true },
            { 
                dataField: "category", 
                text: "Age Group", 
                headerStyle: { backgroundColor: '#fcb92c' }, 
                editable: false 
            },
            { 
                dataField: "gender", 
                text: "Gender", 
                headerStyle: { backgroundColor: '#fcb92c' }, 
                formatter: (cell, row) => row.category.includes('Adults') ? cell : 'N/A', 
                editable: false 
            },
            { 
                dataField: "count", 
                text: "Count", 
                headerStyle: { backgroundColor: '#fcb92c' }, 
                editor: { type: Type.NUMBER },
                validator: (newValue) => {
                    if (newValue < 0) {
                        return { valid: false, message: 'Count cannot be negative' };
                    }
                    return true;
                }
            }
        ];

        return (
            <React.Fragment key={"pax-Detail"}>
                <Row>
                    <Col xs={12}>
                        <Card>
                            {!["tour completed"].includes(itinerary.status) && this.props.user?.role !== 1 ? 
                                <CardBody>
                                    <div className="table-responsive">
                                        <BootstrapTable
                                            keyField="id"
                                            data={tableData}
                                            columns={paxColumns}
                                            cellEdit={cellEditFactory({ 
                                                mode: 'click',
                                                blurToSave: true,
                                                beforeSaveCell: (oldValue, newValue, row) => {
                                                    const numValue = parseInt(newValue) || 0;
                                                    this.handleCountChange(numValue, row);
                                                }
                                            })}
                                        />
                                    </div>
                                </CardBody>
                            :
                                <CardBody>
                                    <div className="table-responsive">
                                        <BootstrapTable
                                            keyField="id"
                                            data={tableData}
                                            columns={paxColumns}
                                        />
                                    </div>
                                </CardBody>
                            }
                        </Card>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

export default PaxDetail;